module.exports = __webpack_public_path__ + "img/ic-warning.2c7c5db5.svg";